<template>
  <div ref="container">
    <JadeGroupHeader>{{ $t('title') }}</JadeGroupHeader>

    <JadeListItem
      :label="$t('acquirer')"
      :trailing="data.acquirer"
    />

    <JadeDivider />

    <JadeListItem :label="$t('acquirer-message')">
      <template #trailing>
        <div
          v-if="data.message"
          class="flex items-center gap-2 max-w-60"
        >
          <jade-text
            color="medium"
            variant="text-medium"
            weight="medium"
          >
            {{ data.message }}
          </jade-text>
        </div>
      </template>
    </JadeListItem>

    <JadeDivider />

    <JadeListItem
      :label="$t('acquirer-return-code')"
      :trailing="data.returnCode"
    />

    <JadeDivider />

    <JadeListItem
      v-if="data.operationType"
      :label="$t('operation-type')"
      :trailing="data.operationType"
    >
      <template #trailing>
        <JadeTag
          size="medium"
          variant="neutral"
        >
          {{ data.operationType }}
        </JadeTag>
      </template>
    </JadeListItem>

    <JadeDivider />

    <JadeListItem
      :label="$t('tid')"
      :tooltip="$t('tid-description')"
    >
      <template #trailing>
        <div
          v-if="data.tid"
          class="flex items-center gap-2"
        >
          <jade-text
            color="medium"
            variant="text-medium"
            weight="medium"
          >
            {{ data.tid }}
          </jade-text>
          <jade-icon-button
            size="small"
            icon="action-copy"
            @click="handleCopy(data.tid)"
          />
        </div>

        <span v-else> - </span>
      </template>
    </JadeListItem>

    <JadeDivider />

    <JadeListItem
      :label="$t('nsu')"
      :tooltip="$t('nsu-description')"
    >
      <template #trailing>
        <div
          v-if="data.nsu"
          class="flex items-center gap-2"
        >
          <jade-text
            color="medium"
            variant="text-medium"
            weight="medium"
          >
            {{ data.nsu }}
          </jade-text>
          <jade-icon-button
            size="small"
            icon="action-copy"
            @click="handleCopy(data.nsu)"
          />
        </div>
        <span v-else> - </span>
      </template>
    </JadeListItem>

    <JadeDivider />

    <JadeListItem :label="$t('auth-code')">
      <template #trailing>
        <div
          v-if="data.autorizationCode"
          class="flex items-center gap-2"
        >
          <jade-text
            color="medium"
            variant="text-medium"
            weight="medium"
          >
            {{ data.autorizationCode }}
          </jade-text>
          <jade-icon-button
            size="small"
            icon="action-copy"
            @click="handleCopy(data.autorizationCode)"
          />
        </div>
        <span v-else> - </span>
      </template>
    </JadeListItem>

    <JadeDivider />

    <JadeListItem :label="$t('pgid')">
      <template #trailing>
        <div class="flex items-center gap-2 max-w-56">
          <jade-text
            color="medium"
            variant="text-medium"
            weight="medium"
          >
            {{ data.pgid }}
          </jade-text>
          <jade-icon-button
            size="small"
            icon="action-copy"
            @click="handleCopy(data.pgid)"
          />
        </div>
      </template>
    </JadeListItem>

    <JadeDivider />

    <JadeListItem :label="$t('orderKey')">
      <template #trailing>
        <div class="flex items-center gap-2 max-w-56">
          <jade-text
            color="medium"
            variant="text-medium"
            weight="medium"
          >
            {{ data.orderKey }}
          </jade-text>
          <jade-icon-button
            size="small"
            icon="action-copy"
            @click="handleCopy(data.orderKey)"
          />
        </div>
      </template>
    </JadeListItem>

    <JadeDivider />
  </div>
</template>

<script>
import {
  JadeGroupHeader,
  JadeText,
  JadeDivider,
  JadeListItem,
  JadeIconButton,
  JadeTag
} from '@jade'

export default {
  name: 'LayoutDataAcquirer',

  components: {
    JadeGroupHeader,
    JadeText,
    JadeDivider,
    JadeListItem,
    JadeIconButton,
    JadeTag
  },

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  methods: {
    handleCopy (value) {
      this.$emit('handleCopied', value)
      this.$copyText(value, this.$refs.container)
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "title": "Dados da adquirente",
      "acquirer": "Adquirente",
      "acquirer-return-code": "Código de retorno",
      "operation-type": "Tipo da operação",
      "acquirer-message": "Mensagem",
      "auth-code": "Código de autorização",
      "tid": "TID",
      "tid-description": "Transaction ID é um número de identificação (ou de autorização) da transação de e-commerce na operadora.",
      "nsu": "NSU",
      "nsu-description": "Número sequencial único é o número de identificação de uma operação de venda realizada com cartões. É atribuído a cada documento fiscal emitido.",
      "pgid": "Chave da transação",
      "orderKey": "Chave do pedido"
    },
    "en-US": {
      "title": "Acquirer data",
      "acquirer": "Acquirer",
      "acquirer-return-code": "Return code",
      "operation-type": "Type of operation",
      "acquirer-message": "Message",
      "auth-code": "Authorization code",
      "tid": "TID",
      "tid-description": "Transaction ID is an identification (or authorization) number for the e-commerce transaction at the operator.",
      "nsu": "NSU",
      "nsu-description": "Unique sequential number is the identification number of a sales transaction carried out with cards. It is assigned to each tax document issued.",
      "pgid": "Transaction key",
      "orderKey": "Order key"
    }
  }
</i18n>
